import Home from "@/views/Home.vue";
import About from "@/views/About.vue";
import { Trans } from "@/plugins/Translation";
import Unauthorized from "../views/Auth/Unauthorized.vue";
import Callback from "../views/Auth/Callback.vue";
import Support from "@/views/Support.vue"
import Profile from "@/views/Profile.vue"
import Quotations from "@/views/Quotations.vue"
import Division from "@/views/Division.vue"
import Communications from "@/views/Communications.vue"
import Admin from "@/views/Admin.vue"
import LoadCommunication from "@/views/LoadCommunication.vue"
import authPlugin from '../api/Auth/AuthPlugin';
import Vue from "vue";
import store from "../store/index"

const routes = [
    {
        path: "/:lang",
        component: {
            template: "<router-view></router-view>"
        },
        beforeEnter: (to, from, next) => {
            Vue.prototype.$GAUserAuth.refreshUserInfo().then((authenticated) => {
                if (authenticated) {
                    const lang = to.params.lang;
                    if (!Trans.isLangSupported(lang)) return next(Trans.getUserSupportedLang());
                    return Trans.changeLanguage(lang).then(() => next());
                }
                else {
                    store.commit("SET_showHeader", false);
                }
            });
        },
        children: [
            {
                path: "/",
                name: "home",
                component: Home,
                meta: {
                    requiresAuth: false
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "distribution",
                name: "distribution",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: About,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "support",
                name: "support",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: Support,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "profile",
                name: "profile",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: Profile,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "quotations/:DivisionId?",
                name: "quotations",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: Quotations,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "division/:DivisionId?",
                name: "division",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: Division,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "communications",
                name: "communications",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: Communications,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "admin",
                name: "admin",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: Admin,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "loadCommunication/:isLoad?",
                name: "loadCommunication",
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: LoadCommunication,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            },
            {
                path: "callback",
                name: "callback",
                component: Callback,
                meta: {
                    requiresAuth: true
                    // role: "base",
                    // function: "Menu Utente"
                }
            }
        ]
    },
    {
        // Redirect user to supported lang version.
        path: "*",
        // eslint-disable-next-line
        redirect(to) {
            return Trans.getUserSupportedLang();
        },

    },
    {
        path: "unauthorized",
        name: "unauthorized",
        beforeEnter(to, from, next) {
            var hostName = window.location.hostname;
            window.location.replace(this.$genericClass.GetSSOUrl() + "/Home/Index/?r=" + btoa(hostName));
        },
        meta: {
            requiresAuth: true
            // role: "base",
            // function: "Menu Utente"
        }
    }
];

export default routes;
